import React, { FC } from 'react';
import s from './physicalToysSection.module.scss';
import { LogoLoader } from '@components/UIKit/LogoLoader/LogoLoader';
import cn from 'classnames';
import { useTranslation } from '@hooks/useTranslation';
import { useGetShopifyList } from '@services/toys/hooks/useGetShopifyList';
import { ShopifyItem } from '@components/Cards/ShopifyItem/ShopifyItem';
interface Props {}
export const PhysicalToysSection: FC<Props> = ({}) => {
  const {
    translate: tr
  } = useTranslation();
  const {
    data,
    isLoading
  } = useGetShopifyList({
    status: 'ACTIVE'
  });
  return <div className={s.physicalToysSection} data-sentry-component="PhysicalToysSection" data-sentry-source-file="PhysicalToysSection.tsx">
            <h3 className={cn(s.physicalToysSection__title)}>
                {tr({
        id: 'explore.page.physical.artists.title'
      })}
            </h3>
            {isLoading ? <LogoLoader /> : !!data?.products?.length && <div className={s.physicalToysSection__grid}>
                    {data.products.map(item => <ShopifyItem key={item.id} {...item} />)}
                </div>}
        </div>;
};